export default "__VITE_ASSET__BT7VxD90__"